import dayjs from "dayjs";
export const dateAndTimeFormat = "DD.MM.YYYY HH:mm";
export const formatDateAndTime = (date) => {
    if (!date)
        return "";
    const safedDate = dayjs(date);
    const isValid = safedDate.isValid();
    if (!isValid)
        return "invalid date";
    return safedDate.format(dateAndTimeFormat);
};
